import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    beneficariesErrorNote:
      'Some of your beneficial owners’ identity could not be verified.',
    beneficariesProgressNote:
      '{totalBeneficiariesCompleted}/{totalBeneficiaries} have completed their information so far.',
    beneficiariesDocuments: 'Follow their progress',
    beneficiariesPendingNote:
      'All beneficial owners have completed their information.',
    beneficiaryPersonalStatus: 'Fill in your information',
    companyInfo: 'Add the company’s statutes',
    companyInfoSent: 'Company’s statutes',
    draftStatutesStatus: 'Add the company’s draft statutes',
    draftStatutesStatusSent: 'Draft statutes',
    proofOfAddress: 'Add proof of address',
    proofOfAddressSent: 'Proof of address',
    proofOfId: 'Add proof of identity',
    proofOfIdSent: 'Proof of identity',
    refusedAddressNote: 'Replace the document',
    refusedIdNote: 'Replace the document',
    shineStartStepDescription:
      'Required documents to create your micro-entreprise',
    shineStartStepTitle: 'My Micro-Entreprise',
  },
  fr: {
    beneficariesErrorNote:
      'L’identité de certains de vos bénéficiaires n’a pas pu être vérifiée.',
    beneficariesProgressNote:
      '{totalBeneficiariesCompleted}/{totalBeneficiaries} ont renseigné leurs informations.',
    beneficiariesDocuments: 'Suivre la progression',
    beneficiariesPendingNote:
      'Tous les bénéficiaires effectifs ont renseigné leurs informations\u00A0!',
    beneficiaryPersonalStatus: 'Complétez vos informations',
    companyInfo: 'Ajouter les statuts de l’entreprise',
    companyInfoSent: 'Statuts de l’entreprise',
    draftStatutesStatus: 'Ajouter les projets de statuts de l’entreprise',
    draftStatutesStatusSent: 'Projets de statuts de l’entreprise',
    proofOfAddress: 'Ajouter un justificatif de domicile',
    proofOfAddressSent: 'Justificatif de domicile',
    proofOfId: 'Ajouter une preuve d’identité',
    proofOfIdSent: 'Preuve d’identité',
    refusedAddressNote: 'Remplacer le document',
    refusedIdNote: 'Remplacer le document',
    shineStartStepDescription: 'Documents requis pour créer votre entreprise',
    shineStartStepTitle: 'Ma micro-entreprise',
  },
} as const);
